import type { TData } from "../types";

const TOKEN_RE = /^\{\{\s*([^{}\s]+)\s*\}\}$/;

/**
 * Walk the chart data matrix and substitute each cell's resolved value
 * (looked up in `versionData` via `cell.variable`) into `cell.value`.
 * Cells without a `{{token}}` binding pass through untouched.
 */
export const resolveCellVariables = (
  data: TData,
  versionData: Record<string, unknown> | undefined,
): TData =>
  data.map((row) =>
    row.map((cell) => {
      if (!cell?.variable) return cell;
      const match = cell.variable.match(TOKEN_RE);
      const token = match?.[1];
      if (!token) return cell;
      const resolved = versionData?.[token];
      if (resolved == null) return cell;
      return { ...cell, value: String(resolved) };
    }),
  );
